/**
 * Hexagon component — core brand shape (Bootcamp Institute geometric language).
 * Used as logo isotipo, decorative pattern, badge frame.
 */
const POINTS = '50,2 95,27 95,73 50,98 5,73 5,27';

export function Hex({
  size = 24,
  fill = 'currentColor',
  stroke,
  strokeWidth = 0,
  className,
  rotate = 0,
}: {
  size?: number;
  fill?: string;
  stroke?: string;
  strokeWidth?: number;
  className?: string;
  rotate?: number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      style={rotate ? { transform: `rotate(${rotate}deg)` } : undefined}
      aria-hidden
    >
      <polygon points={POINTS} fill={fill} stroke={stroke ?? 'none'} strokeWidth={strokeWidth} />
    </svg>
  );
}

/**
 * Decorative hexagon grid pattern — subtle background motif.
 * Used in hero and detail page backgrounds.
 */
export function HexPattern({ className, opacity = 0.06 }: { className?: string; opacity?: number }) {
  return (
    <svg className={className} viewBox="0 0 200 200" preserveAspectRatio="xMidYMid slice" aria-hidden>
      <defs>
        <pattern id="hexpat" x="0" y="0" width="36" height="62" patternUnits="userSpaceOnUse">
          <polygon points="18,0 36,10 36,30 18,40 0,30 0,10" fill="none" stroke="var(--bi-primario)" strokeWidth="0.6" opacity={opacity} />
          <polygon points="0,30 18,40 18,60 0,70 -18,60 -18,40" fill="none" stroke="var(--bi-primario)" strokeWidth="0.6" opacity={opacity} />
          <polygon points="36,30 54,40 54,60 36,70 18,60 18,40" fill="none" stroke="var(--bi-primario)" strokeWidth="0.6" opacity={opacity} />
        </pattern>
      </defs>
      <rect width="200" height="200" fill="url(#hexpat)" />
    </svg>
  );
}
